import { useEffect, useState } from "react";
import { createGenericContext } from "../../utils/createGenericContext";
import { getCookie, setCookie } from "../../utils/cookies";
import userService from "../../services/user-service";
import contentService from "../../services/content-service";
import { PII_ROUTE } from "../../cms/cms-constants";
import { useNavigate } from "react-router-dom";

export interface IAccountContext {
  isLoggedIn: boolean;
  userId?: string;
  loaded: boolean;
  user: UserModel;
  piiDisabled: boolean;
  susDisabled: boolean;
  edq5Disabled: boolean;
  virtualArmDisabled: boolean;
  formQuestionsWithPII: any;
  doLogout: () => void;
  doLogin: (id: string) => void;
  reloadUser: () => void
  warningContent: string
}

export interface UserModel {
  ageBand: string[];
  sex: string[];
  currentVAAccess: string[];
  userType: string[];
  uniqueCode: string;
  favourites: string;
}

const [useAccount, AccountContextProvider] =
  createGenericContext<IAccountContext>();

const AccountProvider = ({ children }: any) => {
  const navigate = useNavigate()
  const [isLoggedIn, setLoggedIn] = useState<boolean>(false);
  const [userId, setUserId] = useState<string>();
  const [user, setUser] = useState<any>();
  const [loaded, setLoaded] = useState<boolean>(false);

  const [piiDisabled, setPiiDisabled] = useState<boolean>(false);
  const [susDisabled, setSUSDisabled] = useState<boolean>(false);
  const [edq5Disabled, setEDQ5Disabled] = useState<boolean>(false);
  const [virtualArmDisabled, setVirtualArmDisabled] = useState<boolean>(false);
  const [formQuestionsWithPII, setformQuestionsWithPII] = useState<any>()
  const [warningContent, setWarningContent] = useState<any>()


  useEffect(() => {
    contentService.getContent(PII_ROUTE).then((s) => {
      setPiiDisabled(!s.data.enablePII);
      setEDQ5Disabled(!s.data.enableEDQ5);
      setSUSDisabled(!s.data.enableSUS);
      setVirtualArmDisabled(!s.data.enableVirtualArm)
      setWarningContent(s.data.warningContent || "<p data-prosemirror-content-type=\"node\" data-prosemirror-node-name=\"paragraph\" data-prosemirror-node-block=\"true\" data-pm-slice=\"1 1 []\">In an <strong data-prosemirror-content-type=\"mark\" data-prosemirror-mark-name=\"strong\">emergency</strong>, or if your fistula / graft / line is <strong data-prosemirror-content-type=\"mark\" data-prosemirror-mark-name=\"strong\">bleeding</strong> and does not stop with firm pressure call 999 and state you are bleeding from your dialysis fistula / graft / line</p>")
    });
  }, []);

  useEffect(() => {
    const c = getCookie("kduser");

    setLoggedIn(c !== null);

    if (c !== null && c !== userId) {
      setUserId(c);
      return;
    }

    setLoaded(true);
  }, [userId]);

  const doLogout = () => {
    setUserId(undefined);
    setUser(undefined);
    setCookie("kduser", "", -10);

    navigate("/logged-out")
  };

  const doLogin = (id: string) => {
    setCookie("kduser", id, 30);
    setUserId(id);
  };

  useEffect(() => {
    reloadUser()
  }, [userId]);

  const reloadUser = () => {
    if (userId) {
      userService.getUser(userId).then((res: any) => {
        setUser(res.data);
      });
    }
  }

  let contextValue = {
    isLoggedIn,
    loaded,
    user,
    userId,
    doLogin,
    doLogout,
    piiDisabled,
    edq5Disabled,
    susDisabled,
    virtualArmDisabled,
    formQuestionsWithPII,
    reloadUser,
    warningContent
  };

  return (
    <AccountContextProvider value={contextValue}>
      {children}
    </AccountContextProvider>
  );
};

export { AccountProvider, useAccount };
